import React from 'react'
import PropTypes from 'prop-types'
import { ButtonGroup } from 'react-bootstrap'

const ButtonGroup3 = ({ children, ...props }) => (
  <ButtonGroup
    {...props}
  >
    {children}
  </ButtonGroup>
)

ButtonGroup3.propTypes = {
  children: PropTypes.node.isRequired
}

ButtonGroup3.defaultProps = {}

export default ButtonGroup3
